import { MessagingPlatform } from '@this+that/models';

import { guardedIntegrationFetch } from './guardedIntegrationFetch';
import { useGetUserWhatsAppIntegrations } from '../../services/meta.service';
import { useIntegrationsStore } from '../../store';

export const useGetWhatsAppIntegrations = () => {
  const { getUserWhatsAppIntegrations } = useGetUserWhatsAppIntegrations();
  const { setUserWhatsAppIntegrations } = useIntegrationsStore();

  const handleFetchWhatsAppIntegrations = (forceRefresh = false) =>
    guardedIntegrationFetch({
      key: MessagingPlatform.WHATSAPP,
      forceRefresh,
      fetch: getUserWhatsAppIntegrations,
      write: setUserWhatsAppIntegrations,
    });

  return { handleFetchWhatsAppIntegrations };
};
